import { render, staticRenderFns } from "./qjxs.vue?vue&type=template&id=83c9f35c"
import script from "./qjxs.vue?vue&type=script&lang=js"
export * from "./qjxs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports